<script>  
  import RadioGroup from '@itslearning/prometheus/assets/inputs/RadioGroup/v1/RadioGroup.svelte';
  import {questionAnswers} from '../../stores';
  import {txt} from '../../i18n/i18n';

  export let question = { };
  export let questionAnswer = null;
  export let readonly = false;

  /**
   * set true if you do not want answer to be displayed, useful when e.g. printing survey
   * @type {boolean}
   */
  export let hideAnswer = false;

  function handleSelected(e) {
    if (hideAnswer) {
        return;
    }
    const alternativeId = e.detail.value;
    answer.alternativeIds = [alternativeId];
  }

  $: answer = questionAnswer ? questionAnswer : $questionAnswers.find(a => a.questionId === question.questionId);
  $: alternatives = question.alternatives.map((a) => ({id: 'C' + a.alternativeId, label: a.text, value: a.alternativeId, disabled: readonly }));
  $: selectedAlternativeId = !hideAnswer && answer && answer.alternativeIds && answer.alternativeIds.length > 0 ? answer.alternativeIds[0] : null;
</script>

<!-- TODO it's an issue that there is a label for the RadioGroup, the question text can be long and contain html -->
<RadioGroup 
        id={'Q' + question.questionId} 
        label={txt('Alternatives')} 
        name={'Q' + question.questionId}
        useSmallRadioButtons={true}
        selected={selectedAlternativeId}
        on:selected={handleSelected}
        options={alternatives} 
        vertical={true}>
</RadioGroup>
